var _defs, _g, _style;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrade(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 151,
    height: 684,
    viewBox: "0 0 151 684",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    width: 151,
    height: 684,
    fill: "none",
    d: "M0 0 L151 0 L151 684 L0 684 Z",
    className: "oKZfqifb_0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Repeti\\xC3\\xA7\\xC3\\xA3o_de_grade_2",
    "data-name": "Repeti\\xC3\\xA7\\xC3\\xA3o de grade 2",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1780 -4797.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_6",
    "data-name": "Linha 6",
    transform: "translate(1780 4798)",
    fill: "none",
    stroke: "#cc8f57",
    strokeWidth: 1,
    d: "M0,0L151,0",
    className: "oKZfqifb_1"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1780 -4776.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_6-2",
    "data-name": "Linha 6",
    transform: "translate(1780 4798)",
    fill: "none",
    stroke: "#cc8f57",
    strokeWidth: 1,
    d: "M0,0L151,0",
    className: "oKZfqifb_2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1780 -4755.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_6-3",
    "data-name": "Linha 6",
    transform: "translate(1780 4798)",
    fill: "none",
    stroke: "#cc8f57",
    strokeWidth: 1,
    d: "M0,0L151,0",
    className: "oKZfqifb_3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1780 -4734.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_6-4",
    "data-name": "Linha 6",
    transform: "translate(1780 4798)",
    fill: "none",
    stroke: "#cc8f57",
    strokeWidth: 1,
    d: "M0,0L151,0",
    className: "oKZfqifb_4"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1780 -4713.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_6-5",
    "data-name": "Linha 6",
    transform: "translate(1780 4798)",
    fill: "none",
    stroke: "#cc8f57",
    strokeWidth: 1,
    d: "M0,0L151,0",
    className: "oKZfqifb_5"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1780 -4692.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_6-6",
    "data-name": "Linha 6",
    transform: "translate(1780 4798)",
    fill: "none",
    stroke: "#cc8f57",
    strokeWidth: 1,
    d: "M0,0L151,0",
    className: "oKZfqifb_6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1780 -4671.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_6-7",
    "data-name": "Linha 6",
    transform: "translate(1780 4798)",
    fill: "none",
    stroke: "#cc8f57",
    strokeWidth: 1,
    d: "M0,0L151,0",
    className: "oKZfqifb_7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1780 -4650.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_6-8",
    "data-name": "Linha 6",
    transform: "translate(1780 4798)",
    fill: "none",
    stroke: "#cc8f57",
    strokeWidth: 1,
    d: "M0,0L151,0",
    className: "oKZfqifb_8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1780 -4629.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_6-9",
    "data-name": "Linha 6",
    transform: "translate(1780 4798)",
    fill: "none",
    stroke: "#cc8f57",
    strokeWidth: 1,
    d: "M0,0L151,0",
    className: "oKZfqifb_9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1780 -4608.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_6-10",
    "data-name": "Linha 6",
    transform: "translate(1780 4798)",
    fill: "none",
    stroke: "#cc8f57",
    strokeWidth: 1,
    d: "M0,0L151,0",
    className: "oKZfqifb_10"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1780 -4587.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_6-11",
    "data-name": "Linha 6",
    transform: "translate(1780 4798)",
    fill: "none",
    stroke: "#cc8f57",
    strokeWidth: 1,
    d: "M0,0L151,0",
    className: "oKZfqifb_11"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1780 -4566.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_6-12",
    "data-name": "Linha 6",
    transform: "translate(1780 4798)",
    fill: "none",
    stroke: "#cc8f57",
    strokeWidth: 1,
    d: "M0,0L151,0",
    className: "oKZfqifb_12"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1780 -4545.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_6-13",
    "data-name": "Linha 6",
    transform: "translate(1780 4798)",
    fill: "none",
    stroke: "#cc8f57",
    strokeWidth: 1,
    d: "M0,0L151,0",
    className: "oKZfqifb_13"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1780 -4524.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_6-14",
    "data-name": "Linha 6",
    transform: "translate(1780 4798)",
    fill: "none",
    stroke: "#cc8f57",
    strokeWidth: 1,
    d: "M0,0L151,0",
    className: "oKZfqifb_14"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1780 -4503.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_6-15",
    "data-name": "Linha 6",
    transform: "translate(1780 4798)",
    fill: "none",
    stroke: "#cc8f57",
    strokeWidth: 1,
    d: "M0,0L151,0",
    className: "oKZfqifb_15"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1780 -4482.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_6-16",
    "data-name": "Linha 6",
    transform: "translate(1780 4798)",
    fill: "none",
    stroke: "#cc8f57",
    strokeWidth: 1,
    d: "M0,0L151,0",
    className: "oKZfqifb_16"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1780 -4461.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_6-17",
    "data-name": "Linha 6",
    transform: "translate(1780 4798)",
    fill: "none",
    stroke: "#cc8f57",
    strokeWidth: 1,
    d: "M0,0L151,0",
    className: "oKZfqifb_17"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1780 -4440.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_6-18",
    "data-name": "Linha 6",
    transform: "translate(1780 4798)",
    fill: "none",
    stroke: "#cc8f57",
    strokeWidth: 1,
    d: "M0,0L151,0",
    className: "oKZfqifb_18"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1780 -4419.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_6-19",
    "data-name": "Linha 6",
    transform: "translate(1780 4798)",
    fill: "none",
    stroke: "#cc8f57",
    strokeWidth: 1,
    d: "M0,0L151,0",
    className: "oKZfqifb_19"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1780 -4398.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_6-20",
    "data-name": "Linha 6",
    transform: "translate(1780 4798)",
    fill: "none",
    stroke: "#cc8f57",
    strokeWidth: 1,
    d: "M0,0L151,0",
    className: "oKZfqifb_20"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1780 -4377.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_6-21",
    "data-name": "Linha 6",
    transform: "translate(1780 4798)",
    fill: "none",
    stroke: "#cc8f57",
    strokeWidth: 1,
    d: "M0,0L151,0",
    className: "oKZfqifb_21"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1780 -4356.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_6-22",
    "data-name": "Linha 6",
    transform: "translate(1780 4798)",
    fill: "none",
    stroke: "#cc8f57",
    strokeWidth: 1,
    d: "M0,0L151,0",
    className: "oKZfqifb_22"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1780 -4335.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_6-23",
    "data-name": "Linha 6",
    transform: "translate(1780 4798)",
    fill: "none",
    stroke: "#cc8f57",
    strokeWidth: 1,
    d: "M0,0L151,0",
    className: "oKZfqifb_23"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1780 -4314.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_6-24",
    "data-name": "Linha 6",
    transform: "translate(1780 4798)",
    fill: "none",
    stroke: "#cc8f57",
    strokeWidth: 1,
    d: "M0,0L151,0",
    className: "oKZfqifb_24"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1780 -4293.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_6-25",
    "data-name": "Linha 6",
    transform: "translate(1780 4798)",
    fill: "none",
    stroke: "#cc8f57",
    strokeWidth: 1,
    d: "M0,0L151,0",
    className: "oKZfqifb_25"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1780 -4272.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_6-26",
    "data-name": "Linha 6",
    transform: "translate(1780 4798)",
    fill: "none",
    stroke: "#cc8f57",
    strokeWidth: 1,
    d: "M0,0L151,0",
    className: "oKZfqifb_26"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1780 -4251.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_6-27",
    "data-name": "Linha 6",
    transform: "translate(1780 4798)",
    fill: "none",
    stroke: "#cc8f57",
    strokeWidth: 1,
    d: "M0,0L151,0",
    className: "oKZfqifb_27"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1780 -4230.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_6-28",
    "data-name": "Linha 6",
    transform: "translate(1780 4798)",
    fill: "none",
    stroke: "#cc8f57",
    strokeWidth: 1,
    d: "M0,0L151,0",
    className: "oKZfqifb_28"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1780 -4209.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_6-29",
    "data-name": "Linha 6",
    transform: "translate(1780 4798)",
    fill: "none",
    stroke: "#cc8f57",
    strokeWidth: 1,
    d: "M0,0L151,0",
    className: "oKZfqifb_29"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1780 -4188.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_6-30",
    "data-name": "Linha 6",
    transform: "translate(1780 4798)",
    fill: "none",
    stroke: "#cc8f57",
    strokeWidth: 1,
    d: "M0,0L151,0",
    className: "oKZfqifb_30"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1780 -4167.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_6-31",
    "data-name": "Linha 6",
    transform: "translate(1780 4798)",
    fill: "none",
    stroke: "#cc8f57",
    strokeWidth: 1,
    d: "M0,0L151,0",
    className: "oKZfqifb_31"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1780 -4146.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_6-32",
    "data-name": "Linha 6",
    transform: "translate(1780 4798)",
    fill: "none",
    stroke: "#cc8f57",
    strokeWidth: 1,
    d: "M0,0L151,0",
    className: "oKZfqifb_32"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1780 -4125.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_6-33",
    "data-name": "Linha 6",
    transform: "translate(1780 4798)",
    fill: "none",
    stroke: "#cc8f57",
    strokeWidth: 1,
    d: "M0,0L151,0",
    className: "oKZfqifb_33"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    "data-made-with": "vivus-instant"
  }, ".oKZfqifb_0{stroke-dasharray:1670 1672;stroke-dashoffset:1671;animation:oKZfqifb_draw_0 6500ms linear 0ms infinite,oKZfqifb_fade 6500ms linear 0ms infinite;}.oKZfqifb_1{stroke-dasharray:151 153;stroke-dashoffset:152;animation:oKZfqifb_draw_1 6500ms linear 0ms infinite,oKZfqifb_fade 6500ms linear 0ms infinite;}.oKZfqifb_2{stroke-dasharray:151 153;stroke-dashoffset:152;animation:oKZfqifb_draw_2 6500ms linear 0ms infinite,oKZfqifb_fade 6500ms linear 0ms infinite;}.oKZfqifb_3{stroke-dasharray:151 153;stroke-dashoffset:152;animation:oKZfqifb_draw_3 6500ms linear 0ms infinite,oKZfqifb_fade 6500ms linear 0ms infinite;}.oKZfqifb_4{stroke-dasharray:151 153;stroke-dashoffset:152;animation:oKZfqifb_draw_4 6500ms linear 0ms infinite,oKZfqifb_fade 6500ms linear 0ms infinite;}.oKZfqifb_5{stroke-dasharray:151 153;stroke-dashoffset:152;animation:oKZfqifb_draw_5 6500ms linear 0ms infinite,oKZfqifb_fade 6500ms linear 0ms infinite;}.oKZfqifb_6{stroke-dasharray:151 153;stroke-dashoffset:152;animation:oKZfqifb_draw_6 6500ms linear 0ms infinite,oKZfqifb_fade 6500ms linear 0ms infinite;}.oKZfqifb_7{stroke-dasharray:151 153;stroke-dashoffset:152;animation:oKZfqifb_draw_7 6500ms linear 0ms infinite,oKZfqifb_fade 6500ms linear 0ms infinite;}.oKZfqifb_8{stroke-dasharray:151 153;stroke-dashoffset:152;animation:oKZfqifb_draw_8 6500ms linear 0ms infinite,oKZfqifb_fade 6500ms linear 0ms infinite;}.oKZfqifb_9{stroke-dasharray:151 153;stroke-dashoffset:152;animation:oKZfqifb_draw_9 6500ms linear 0ms infinite,oKZfqifb_fade 6500ms linear 0ms infinite;}.oKZfqifb_10{stroke-dasharray:151 153;stroke-dashoffset:152;animation:oKZfqifb_draw_10 6500ms linear 0ms infinite,oKZfqifb_fade 6500ms linear 0ms infinite;}.oKZfqifb_11{stroke-dasharray:151 153;stroke-dashoffset:152;animation:oKZfqifb_draw_11 6500ms linear 0ms infinite,oKZfqifb_fade 6500ms linear 0ms infinite;}.oKZfqifb_12{stroke-dasharray:151 153;stroke-dashoffset:152;animation:oKZfqifb_draw_12 6500ms linear 0ms infinite,oKZfqifb_fade 6500ms linear 0ms infinite;}.oKZfqifb_13{stroke-dasharray:151 153;stroke-dashoffset:152;animation:oKZfqifb_draw_13 6500ms linear 0ms infinite,oKZfqifb_fade 6500ms linear 0ms infinite;}.oKZfqifb_14{stroke-dasharray:151 153;stroke-dashoffset:152;animation:oKZfqifb_draw_14 6500ms linear 0ms infinite,oKZfqifb_fade 6500ms linear 0ms infinite;}.oKZfqifb_15{stroke-dasharray:151 153;stroke-dashoffset:152;animation:oKZfqifb_draw_15 6500ms linear 0ms infinite,oKZfqifb_fade 6500ms linear 0ms infinite;}.oKZfqifb_16{stroke-dasharray:151 153;stroke-dashoffset:152;animation:oKZfqifb_draw_16 6500ms linear 0ms infinite,oKZfqifb_fade 6500ms linear 0ms infinite;}.oKZfqifb_17{stroke-dasharray:151 153;stroke-dashoffset:152;animation:oKZfqifb_draw_17 6500ms linear 0ms infinite,oKZfqifb_fade 6500ms linear 0ms infinite;}.oKZfqifb_18{stroke-dasharray:151 153;stroke-dashoffset:152;animation:oKZfqifb_draw_18 6500ms linear 0ms infinite,oKZfqifb_fade 6500ms linear 0ms infinite;}.oKZfqifb_19{stroke-dasharray:151 153;stroke-dashoffset:152;animation:oKZfqifb_draw_19 6500ms linear 0ms infinite,oKZfqifb_fade 6500ms linear 0ms infinite;}.oKZfqifb_20{stroke-dasharray:151 153;stroke-dashoffset:152;animation:oKZfqifb_draw_20 6500ms linear 0ms infinite,oKZfqifb_fade 6500ms linear 0ms infinite;}.oKZfqifb_21{stroke-dasharray:151 153;stroke-dashoffset:152;animation:oKZfqifb_draw_21 6500ms linear 0ms infinite,oKZfqifb_fade 6500ms linear 0ms infinite;}.oKZfqifb_22{stroke-dasharray:151 153;stroke-dashoffset:152;animation:oKZfqifb_draw_22 6500ms linear 0ms infinite,oKZfqifb_fade 6500ms linear 0ms infinite;}.oKZfqifb_23{stroke-dasharray:151 153;stroke-dashoffset:152;animation:oKZfqifb_draw_23 6500ms linear 0ms infinite,oKZfqifb_fade 6500ms linear 0ms infinite;}.oKZfqifb_24{stroke-dasharray:151 153;stroke-dashoffset:152;animation:oKZfqifb_draw_24 6500ms linear 0ms infinite,oKZfqifb_fade 6500ms linear 0ms infinite;}.oKZfqifb_25{stroke-dasharray:151 153;stroke-dashoffset:152;animation:oKZfqifb_draw_25 6500ms linear 0ms infinite,oKZfqifb_fade 6500ms linear 0ms infinite;}.oKZfqifb_26{stroke-dasharray:151 153;stroke-dashoffset:152;animation:oKZfqifb_draw_26 6500ms linear 0ms infinite,oKZfqifb_fade 6500ms linear 0ms infinite;}.oKZfqifb_27{stroke-dasharray:151 153;stroke-dashoffset:152;animation:oKZfqifb_draw_27 6500ms linear 0ms infinite,oKZfqifb_fade 6500ms linear 0ms infinite;}.oKZfqifb_28{stroke-dasharray:151 153;stroke-dashoffset:152;animation:oKZfqifb_draw_28 6500ms linear 0ms infinite,oKZfqifb_fade 6500ms linear 0ms infinite;}.oKZfqifb_29{stroke-dasharray:151 153;stroke-dashoffset:152;animation:oKZfqifb_draw_29 6500ms linear 0ms infinite,oKZfqifb_fade 6500ms linear 0ms infinite;}.oKZfqifb_30{stroke-dasharray:151 153;stroke-dashoffset:152;animation:oKZfqifb_draw_30 6500ms linear 0ms infinite,oKZfqifb_fade 6500ms linear 0ms infinite;}.oKZfqifb_31{stroke-dasharray:151 153;stroke-dashoffset:152;animation:oKZfqifb_draw_31 6500ms linear 0ms infinite,oKZfqifb_fade 6500ms linear 0ms infinite;}.oKZfqifb_32{stroke-dasharray:151 153;stroke-dashoffset:152;animation:oKZfqifb_draw_32 6500ms linear 0ms infinite,oKZfqifb_fade 6500ms linear 0ms infinite;}.oKZfqifb_33{stroke-dasharray:151 153;stroke-dashoffset:152;animation:oKZfqifb_draw_33 6500ms linear 0ms infinite,oKZfqifb_fade 6500ms linear 0ms infinite;}@keyframes oKZfqifb_draw{100%{stroke-dashoffset:0;}}@keyframes oKZfqifb_fade{0%{stroke-opacity:1;}93.84615384615384%{stroke-opacity:1;}100%{stroke-opacity:0;}}@keyframes oKZfqifb_draw_0{1.5384615384615385%{stroke-dashoffset: 1671}32.30769230769231%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes oKZfqifb_draw_1{2.0046620046620047%{stroke-dashoffset: 152}32.773892773892776%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes oKZfqifb_draw_2{2.470862470862471%{stroke-dashoffset: 152}33.24009324009324%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes oKZfqifb_draw_3{2.937062937062937%{stroke-dashoffset: 152}33.70629370629371%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes oKZfqifb_draw_4{3.4032634032634035%{stroke-dashoffset: 152}34.17249417249417%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes oKZfqifb_draw_5{3.86946386946387%{stroke-dashoffset: 152}34.63869463869464%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes oKZfqifb_draw_6{4.335664335664335%{stroke-dashoffset: 152}35.10489510489511%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes oKZfqifb_draw_7{4.801864801864801%{stroke-dashoffset: 152}35.57109557109557%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes oKZfqifb_draw_8{5.268065268065268%{stroke-dashoffset: 152}36.03729603729604%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes oKZfqifb_draw_9{5.734265734265734%{stroke-dashoffset: 152}36.50349650349651%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes oKZfqifb_draw_10{6.200466200466201%{stroke-dashoffset: 152}36.96969696969697%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes oKZfqifb_draw_11{6.666666666666667%{stroke-dashoffset: 152}37.43589743589744%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes oKZfqifb_draw_12{7.1328671328671325%{stroke-dashoffset: 152}37.9020979020979%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes oKZfqifb_draw_13{7.599067599067599%{stroke-dashoffset: 152}38.36829836829837%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes oKZfqifb_draw_14{8.065268065268064%{stroke-dashoffset: 152}38.83449883449883%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes oKZfqifb_draw_15{8.53146853146853%{stroke-dashoffset: 152}39.3006993006993%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes oKZfqifb_draw_16{8.997668997668997%{stroke-dashoffset: 152}39.76689976689977%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes oKZfqifb_draw_17{9.463869463869463%{stroke-dashoffset: 152}40.23310023310023%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes oKZfqifb_draw_18{9.93006993006993%{stroke-dashoffset: 152}40.6993006993007%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes oKZfqifb_draw_19{10.396270396270396%{stroke-dashoffset: 152}41.16550116550117%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes oKZfqifb_draw_20{10.862470862470863%{stroke-dashoffset: 152}41.63170163170163%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes oKZfqifb_draw_21{11.328671328671328%{stroke-dashoffset: 152}42.0979020979021%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes oKZfqifb_draw_22{11.794871794871796%{stroke-dashoffset: 152}42.56410256410257%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes oKZfqifb_draw_23{12.261072261072261%{stroke-dashoffset: 152}43.03030303030303%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes oKZfqifb_draw_24{12.727272727272727%{stroke-dashoffset: 152}43.49650349650349%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes oKZfqifb_draw_25{13.193473193473192%{stroke-dashoffset: 152}43.96270396270396%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes oKZfqifb_draw_26{13.65967365967366%{stroke-dashoffset: 152}44.42890442890443%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes oKZfqifb_draw_27{14.125874125874127%{stroke-dashoffset: 152}44.89510489510489%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes oKZfqifb_draw_28{14.592074592074592%{stroke-dashoffset: 152}45.36130536130536%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes oKZfqifb_draw_29{15.058275058275058%{stroke-dashoffset: 152}45.82750582750583%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes oKZfqifb_draw_30{15.524475524475525%{stroke-dashoffset: 152}46.29370629370629%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes oKZfqifb_draw_31{15.990675990675992%{stroke-dashoffset: 152}46.75990675990676%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes oKZfqifb_draw_32{16.456876456876458%{stroke-dashoffset: 152}47.22610722610723%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes oKZfqifb_draw_33{16.923076923076923%{stroke-dashoffset: 152}47.69230769230769%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrade);
export default __webpack_public_path__ + "static/media/grade.57eedcd0f21a76279181080614520a58.svg";
export { ForwardRef as ReactComponent };